import { IfpLoansDropdownWizardData } from '@sec-loans-ui/common/steps/assistance-step/components/ipf-loans-dropdown/IfpLoansDropdown'
import { IfpLoan } from '@shared/sec-loans'
import { useLanguage } from '@ui-common/hooks'
import { formatFinnishCurrencyWithSymbol } from '@ui-common/utils'
import { FormRadioGroup } from '@ui-components/form/FormRadioGroup'
import { FormGroupOption } from '@ui-components/global/ComponentProps'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

export const ManyLoansView = ({ ifpLoans }: { ifpLoans: IfpLoan[] }) => {
  const { formatMessage } = useIntl()
  const formContext = useFormContext<IfpLoansDropdownWizardData>()
  const { currentLang } = useLanguage()

  const options = ifpLoans.map(
    (loan) =>
      ({
        key: loan.creditId,
        label: loan.description[currentLang],
        description: `${loan.iban} (${formatFinnishCurrencyWithSymbol(loan.balance)})`,
      }) satisfies FormGroupOption,
  )

  return (
    <FormRadioGroup
      required={true}
      id="selectedCreditId"
      label={formatMessage({ id: 'loans-assistance-ifp-loans-type-label' })}
      options={options}
      error={formContext.formState.errors.selectedCreditId?.message}
      {...formContext.register('selectedCreditId')}
    />
  )
}
